import type { FIXED_INDENTS } from 'vars/index'

import { styled } from '@linaria/react'
import { LAYOUT, MEDIA } from 'vars/index'

export const GridSkeletonInnerSC = styled.div<{
  paddings: (LAYOUT | FIXED_INDENTS)[]
}>`
  padding: ${({ paddings }) =>
    paddings && paddings.length > 0
      ? paddings.map((item) => `var(${item})`)?.join(' ')
      : 0};
`

export const GridSkeletonTitleSC = styled.div`
  width: 35%;
  background-color: var(--componentsBGColor);
  margin-bottom: var(${LAYOUT.VerticalGridTitleCategoryPaddings});
  height: 44px;

  ${MEDIA.MIN_1240} {
    height: 72px;
  }
`

export const GridSkeletonBundleTitleSC = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 124px;
  width: 100%;
  flex-direction: column;

  ${GridSkeletonTitleSC} {
    width: 30%;
    height: 32px;
    margin-bottom: 10px;

    &:last-child {
      width: 60%;
      height: 24px;
    }
  }

  ${MEDIA.MIN_1240} {
    height: 200px;

    ${GridSkeletonTitleSC} {
      width: 30%;
      height: 60px;
      margin-bottom: 10px;

      &:last-child {
        width: 60%;
        height: 30px;
      }
    }
  }
`
export const GridSkeletonSC = styled.div<{
  cardsAspectRatio: number
  rowGap: FIXED_INDENTS
  cardCount: number
  totalRows: number
}>`
  --gap: ${({ rowGap }) => `var(${rowGap})`};
  --totalRows: ${({ totalRows }) => totalRows};
  --cardsCount: ${({ cardCount }) => cardCount};
  --heaghtCard: ${({ cardsAspectRatio }) =>
    `calc(var(--cardWidth) / ${cardsAspectRatio})`};
  --cardWidth: calc(
    (
        100vw - var(${LAYOUT.HorizontalPaddings}) * 2 -
          (var(--cardsCount) - 1) * var(--gap)
      ) /
      var(--cardsCount)
  );
  display: grid;
  grid-template-columns: repeat(var(--cardsCount), var(--cardWidth));
  grid-template-rows: auto;
  grid-gap: var(--gap);
  height: 100%;
  flex: 0 0 auto;

  & > * {
    background-color: var(--componentsBGColor);
    width: var(--cardWidth);
    height: var(--heaghtCard);
  }
`
